module.exports = __webpack_public_path__ + "img/teams.77333d1c.svg";